export default "__VITE_ASSET__BjgK11Y3__"